import { keyframes } from "styled-components";

export const slideIn = keyframes`
  from {
    width: 0;
    overflow: hidden;
  }
  99% {
    overflow: hidden;
  }
  to {
    width: var(--anim-width);
    overflow: auto;
  }
`;

export const slideOut = keyframes`
  from {
    width: var(--anim-width);
    overflow: hidden;
  }
  to {
    width: 0;
    overflow: hidden;
  }
`;
